
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { TOAST_TYPE } from '@shared/constants/toast.constants';
import { ToastService } from '@shared/services/toast/toast.service';

@Component({
    selector: 'avenir-toast',
    imports: [
        NgbToastModule,
        FormsModule
    ],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss'
})
export class ToastComponent {
  readonly TOAST_TYPE = TOAST_TYPE;

  constructor(protected toastService: ToastService) {}
}
